import { render, staticRenderFns } from "./layout-chat-main-v2.vue?vue&type=template&id=b4399b14&scoped=true"
import script from "./layout-chat-main-v2.vue?vue&type=script&lang=js"
export * from "./layout-chat-main-v2.vue?vue&type=script&lang=js"
import style0 from "./layout-chat-main-v2.vue?vue&type=style&index=0&id=b4399b14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\wwwroot\\deepcityAI\\user-client-pc\\user-client-common-pc\\node_modules\\@vue\\vue-loader-v15\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4399b14",
  null
  
)

export default component.exports